function loadJScript() {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://api.map.baidu.com/api?v=2.0&ak=tSsXhZIBxcX1gpucGARhAwebP7odll1G&callback=init";
    document.body.appendChild(script);
}
window.onload = loadJScript;


//////////////////
// WEBPACK FOOTER
// ./static/js/bdMap.js
// module id = i8hX
// module chunks = 135